import { useParams } from 'react-router-dom';

import Default from '@/resources/themes/productMenu/default';

import { PageContext } from '../../components/contexts/PageContext';
import { useTemplateByPage } from '../../hooks/useTemplateByPage';

function ProductMenu() {
  const { id, name } = useParams<{ id: string; name: string }>();

  const template = useTemplateByPage('product-menu');

  function renderProductMenuTemplate() {
    switch (template?.template_name) {
      default:
        return <Default catalog={{ id: Number(id), name }} />;
    }
  }

  return (
    <PageContext.Provider value={{ template }}>{renderProductMenuTemplate()}</PageContext.Provider>
  );
}

export default ProductMenu;
